export default function StatisticsCard({
  lightColor = "white",
  darkColor = "white",
  text = "",
  statistic = "",
  Icon = "",
  mainTextColor = "navy",
  height = "175px",
}) {
  return (
    <div
      className="p-3  card-st d-flex flex-column border border-2"
      style={{
        backgroundImage: `linear-gradient(to right, ${lightColor} , ${darkColor})`,
        backgroundColor: "red",
        borderRadius: "15px",
        color: mainTextColor,
        height: height,
      }}
    >
      <div
        className="text "
        style={{ fontWeight: "bold", minHeight: "45px", lineHeight: "1.3" }}
      >
        {text}
      </div>
      <div
        className="mt-3  d-flex justify-content-between mb-2 "
        style={{ height: 70 }}
      >
        <div
          className="align-self-baseline fw-bolder px-1 flex-grow-1 text-center pb-1 statistic"
          style={{ fontSize: 50 }}
        >
          {statistic}
        </div>
        <div
          className="align-self-end p-2 rounded-pill d-flex align-items-center justify-content-center icon"
          style={{ backgroundColor: mainTextColor, height: 40, width: 40 }}
        >
          {Icon}
        </div>
      </div>
    </div>
  );
}
